import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type ContentBodyProps = ComponentProps<'div'>;

export function ContentBody({ className, ...props }: ContentBodyProps) {
  return (
    <div
      className={twMerge(
        'min-h-0 flex-1 overflow-y-auto bg-gray-50 md:rounded-b-xl',
        className,
      )}
      {...props}
    />
  );
}
